const translations = { options: 'Opções', selectChecklist: 'Seleção de questionário', checklist: 'Questionário' }

export default translations
